// ============================================================================
// Aarambh.KD — CENTRAL SITE CONFIG
// Update business info, contact, map, images and content here. Nothing else.
// ============================================================================

export const business = {
  name: "Aarambh.KD",
  fullName: "Aarambh.KD Events & Celebrations",
  poweredBy: "Kanakadurga Tent House",
  tagline: "Crafting Extraordinary Celebrations",
  phone: "+91 72077 95556",
  phoneRaw: "+917207795556",
  whatsapp: "917207795556", // used in wa.me link
  email: "aarambh.kd@gmail.com",
  address:
    "Kanakadurga Tent House, 8HGF+67G, Vanasthalipuram Rd, Gautham Nagar, Vanasthalipuram, Hyderabad, Telangana 500070",
  // Google Maps embed. Replace 'q' with a new address to update the pin.
  mapEmbed:
    "https://www.google.com/maps?q=Kanakadurga%20Tent%20House%2C%20Vanasthalipuram%20Rd%2C%20Gautham%20Nagar%2C%20Vanasthalipuram%2C%20Hyderabad%2C%20Telangana%20500070&output=embed",
  mapLink: "https://share.google/I7A4GPuTlZfwaYd7s",
  // Provide official URLs to reveal icons. Leave empty to hide.
  socials: {
    instagram: "",
    facebook: "",
    youtube: "",
  },
};

// ----------------------------------------------------------------------------
// WHATSAPP — deep-link messages (all editable). {name} is auto-filled per package.
// The floating button uses `general`; each package button uses `packages[name]`.
// ----------------------------------------------------------------------------
export const whatsappMessages = {
  general:
    "Hello Aarambh.KD Team,\n\nI would like to know more about your event management services. Please share the available packages and details.",
  packages: {
    Essential:
      "Hello Aarambh.KD Team,\n\nI'm interested in the Essential Package for my event. Please share the pricing, inclusions, and availability.",
    Premium:
      "Hello Aarambh.KD Team,\n\nI'm interested in the Premium Package for my event. Please share the pricing, inclusions, and availability.",
    Luxury:
      "Hello Aarambh.KD Team,\n\nI'm interested in the Luxury Package for my event. Please share the pricing, inclusions, and availability.",
    "Royal Signature":
      "Hello Aarambh.KD Team,\n\nI'm interested in the Royal Signature Package for my event. Please share the pricing, inclusions, and availability.",
  },
};

// Build a WhatsApp deep link with a pre-filled message.
export const waLink = (message) =>
  `https://wa.me/${business.whatsapp}?text=${encodeURIComponent(
    message || whatsappMessages.general
  )}`;

// ----------------------------------------------------------------------------
// HERO BACKGROUND
// Change this single line to use your own photo (e.g. "/gallery/hero.jpg").
// Leave "" to show an elegant luxury gradient placeholder instead.
// ----------------------------------------------------------------------------
export const heroImage =
  "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?auto=format&fit=crop&w=2000&q=80";

// ABOUT images. Edit the "large" featured-card image here anytime (single line).
// Set to "" for a gradient placeholder, or a path like "/gallery/about-1.jpg".
export const aboutImages = {
  // Featured card — premium floral event décor (replaces the earlier bridal portrait).
  large:
    "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1000&q=80",
  small:
    "https://images.pexels.com/photos/12024171/pexels-photo-12024171.jpeg?auto=compress&cs=tinysrgb&w=800",
};

export const aboutHighlights = [
  "Experienced Team",
  "Premium Quality",
  "Customized Planning",
  "Complete Event Management",
  "Trusted Vendor Network",
  "Professional Execution",
];

export const services = [
  { title: "Wedding Planning", icon: "HeartHandshake", desc: "End-to-end planning for a flawless, elegant wedding day." },
  { title: "Stage Decoration", icon: "Sparkles", desc: "Grand, bespoke stage designs that become the centrepiece." },
  { title: "Floral Decoration", icon: "Flower2", desc: "Fresh, artful florals styled to your palette and theme." },
  { title: "Tent House Setup", icon: "Tent", desc: "Robust infrastructure powered by Kanakadurga Tent House." },
  { title: "Photography", icon: "Camera", desc: "Timeless frames capturing every emotion and detail." },
  { title: "Videography", icon: "Video", desc: "Cinematic films that relive your celebration forever." },
  { title: "Catering Coordination", icon: "UtensilsCrossed", desc: "Curated menus and seamless service coordination." },
  { title: "Entertainment", icon: "Music4", desc: "Artists, music and experiences that elevate the mood." },
  { title: "Corporate Events", icon: "Briefcase", desc: "Polished conferences, launches and gala evenings." },
  { title: "Birthday Celebrations", icon: "Cake", desc: "Joyful, themed birthdays for every age and style." },
  { title: "Engagement Events", icon: "Gem", desc: "Intimate, refined ceremonies to begin your journey." },
  { title: "Housewarming Events", icon: "Home", desc: "Auspicious gatherings styled with warmth and grace." },
];

// ----------------------------------------------------------------------------
// GALLERY
// No stock photos are used. To add YOUR OWN event photos (no code changes):
//   1. Upload image files into  /public/gallery/
//   2. Edit  /public/gallery/manifest.json  and add entries like:
//        [{ "category": "Wedding", "img": "/gallery/my-photo-1.jpg" }, ...]
//   They will appear automatically. Categories must match the list below.
// Alternatively, you may hard-code images in the `gallery` array here instead.
// While empty, elegant "Image Coming Soon" placeholder cards are shown.
// ----------------------------------------------------------------------------
export const galleryCategories = [
  "All", "Wedding", "Reception", "Haldi", "Mehendi", "Birthday", "Corporate", "Stage Decoration", "Tent House Setup",
];

export const gallery = [
  { category: "Wedding", img: "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?auto=format&fit=crop&w=900&q=80" },
  { category: "Stage Decoration", img: "https://images.pexels.com/photos/12024171/pexels-photo-12024171.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { category: "Reception", img: "https://images.unsplash.com/photo-1562050344-f7ad946cee35?auto=format&fit=crop&w=900&q=80" },
  { category: "Mehendi", img: "https://images.unsplash.com/photo-1526047932273-341f2a7631f9?auto=format&fit=crop&w=900&q=80" },
  { category: "Wedding", img: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=900&q=80" },
  { category: "Corporate", img: "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=900&q=80" },
  { category: "Birthday", img: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=900&q=80" },
  { category: "Stage Decoration", img: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=900&q=80" },
];

export const packages = [
  {
    name: "Essential",
    suitableFor: "Intimate gatherings & family functions",
    included: ["Core event planning", "Basic stage & décor", "Tent house setup", "On-site coordination"],
    highlight: false,
  },
  {
    name: "Premium",
    suitableFor: "Weddings, engagements & receptions",
    included: ["Full event planning", "Designer stage & florals", "Photography", "Catering coordination", "Dedicated manager"],
    highlight: false,
  },
  {
    name: "Luxury",
    suitableFor: "Grand weddings & large celebrations",
    included: ["Premium décor & lighting", "Photo + video team", "Entertainment", "Guest management", "Complete vendor network"],
    highlight: false,
  },
  {
    name: "Royal Signature",
    suitableFor: "Flagship, no-compromise celebrations",
    included: ["Bespoke concept & theming", "Luxury multi-day décor", "Cinematic films", "Premium catering & hospitality", "End-to-end white-glove execution"],
    highlight: true,
  },
];

export const whyChooseUs = [
  { title: "Powered by Kanakadurga Tent House", icon: "ShieldCheck" },
  { title: "Experienced Professionals", icon: "Users" },
  { title: "Complete Event Solutions", icon: "LayoutGrid" },
  { title: "Premium Decoration", icon: "Sparkles" },
  { title: "On-Time Delivery", icon: "Clock" },
  { title: "Affordable Custom Packages", icon: "Wallet" },
  { title: "Attention to Detail", icon: "Search" },
  { title: "Customer Satisfaction", icon: "Smile" },
];

export const process = [
  { step: "Consultation", desc: "We listen to your vision, scale and priorities." },
  { step: "Planning", desc: "A tailored roadmap covering every element." },
  { step: "Design & Budget", desc: "Concepts, décor direction and a transparent budget." },
  { step: "Execution", desc: "Precise, on-time delivery managed end-to-end." },
  { step: "Celebrate", desc: "You enjoy the moment while we handle everything." },
];

export const faqs = [
  { q: "Can you customize packages?", a: "Absolutely. Every package is a starting point — we tailor services, scale and styling to match your vision and budget." },
  { q: "Do you provide catering?", a: "Yes, we coordinate curated catering through our trusted vendor network, with menus designed around your event." },
  { q: "How early should we book?", a: "For weddings we recommend 2–4 months in advance. For peak seasons and larger events, earlier is better to secure dates." },
  { q: "Do you manage destination weddings?", a: "Yes. We plan and execute destination celebrations with complete logistics, décor and on-ground coordination." },
  { q: "Do you provide photography?", a: "Yes, professional photography and cinematic videography are available across our packages." },
  { q: "Do you arrange entertainment?", a: "Yes — from live music and artists to curated experiences that elevate the atmosphere of your event." },
];

export const eventTypes = [
  "Wedding", "Reception", "Engagement", "Haldi", "Mehendi",
  "Birthday", "Corporate Event", "Housewarming", "Other",
];
